export class AgendaFilter {
  constructor(items) {
    this.items = items;
  }

  getActiveItems(searchQuery, category, location) {
    return Array.from(this.items).filter((item) => {
      return item.dataset.content.toLowerCase().includes(searchQuery.toLowerCase()) &&
             (category == null || JSON.parse(item.dataset.categories).includes(category)) &&
             (location == null || JSON.parse(item.dataset.locations).includes(location));
    });
  }

  getInactiveItems(activeItems) {
    return Array.from(this.items).filter((item) => !activeItems.includes(item));
  }
}